(function () {
  'use strict';

  if (window.__ECLOOfferV6Loaded) {
    document.dispatchEvent(new CustomEvent('eclo:offer-v6-refresh'));
    return;
  }
  window.__ECLOOfferV6Loaded = true;

  function q(scope, selector) {
    return scope ? scope.querySelector(selector) : null;
  }

  function qa(scope, selector) {
    return scope ? Array.prototype.slice.call(scope.querySelectorAll(selector)) : [];
  }

  function detectMonths(value) {
    var text = String(value || '').toLowerCase();
    var match = text.match(/(\d+)\s*mois/) || text.match(/(\d+)\s*months?/) || text.match(/(\d+)/);
    return match ? parseInt(match[1], 10) : 1;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/\"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function config() {
    return window.ECLOOfferV6 || {};
  }

  function localeFor(root) {
    return String(
      (root && root.dataset && root.dataset.locale) ||
      document.documentElement.lang ||
      'fr'
    ).toLowerCase().split('-')[0];
  }

  function words(locale) {
    if (locale === 'en') {
      return {
        choose: 'Choose my offer', daysAverage: 'days on average', oneTime: 'One-time purchase', subscription: 'Subscription',
        flexible: 'Flexible, no commitment', deliveredEvery: 'Delivered every', month: 'month', months: 'months', days: 'days', perDay: '/ day',
        freeShipping: 'Free shipping', saveMore: 'Save 15% extra', perOrder: 'per order', exclusive: 'Exclusive benefits',
        exclusiveTail: '(gifts, offers, exclusives…)', loyalty: 'Earn loyalty points', loyaltyTail: 'and unlock benefits',
        noCommitment: 'No commitment', cancelAnytime: 'cancel anytime', save: 'Save', withSubscription: 'with subscription',
        add: 'Add to cart', bottleRoutine: '1 bottle = 30 days of routine', regenereRoutine: '1 bottle = 30 days = 60 capsules · 2 capsules/day',
        shippingFrom: 'Free shipping from', ships: 'Ships within 2–4 days', secure: 'Secure payment'
      };
    }

    if (locale === 'es') {
      return {
        choose: 'Elegir mi oferta', daysAverage: 'días de media', oneTime: 'Compra única', subscription: 'Suscripción',
        flexible: 'Flexible, sin compromiso', deliveredEvery: 'Entrega cada', month: 'mes', months: 'meses', days: 'días', perDay: '/ día',
        freeShipping: 'Envío gratis', saveMore: 'Ahorra un 15% adicional', perOrder: 'por pedido', exclusive: 'Ventajas exclusivas',
        exclusiveTail: '(regalos, ofertas, exclusividades…)', loyalty: 'Acumula puntos de fidelidad', loyaltyTail: 'y disfruta de ventajas',
        noCommitment: 'Sin compromiso', cancelAnytime: 'cancela cuando quieras', save: 'Ahorra', withSubscription: 'con la suscripción',
        add: 'Añadir al carrito', bottleRoutine: '1 frasco = 30 días de rutina', regenereRoutine: '1 frasco = 30 días = 60 cápsulas · 2 cápsulas/día',
        shippingFrom: 'Envío gratis desde', ships: 'Enviado en 2–4 días', secure: 'Pago seguro'
      };
    }

    return {
      choose: 'Choisir mon offre', daysAverage: 'jours en moyenne', oneTime: 'Achat unique', subscription: 'Abonnement',
      flexible: 'Flexible sans engagement', deliveredEvery: 'Livré tous les', month: 'mois', months: 'mois', days: 'jours', perDay: '/ jour',
      freeShipping: 'Livraison offerte', saveMore: 'Économisez 15 % supplémentaires', perOrder: 'par commande', exclusive: 'Avantages exclusifs',
      exclusiveTail: '(cadeaux, promos, exclusivités…)', loyalty: 'Cumulez des points fidélité', loyaltyTail: 'et profitez d’avantages',
      noCommitment: 'Sans engagement', cancelAnytime: 'résiliable à tout moment', save: 'Économisez', withSubscription: 'avec l’abonnement',
      add: 'Ajouter au panier', bottleRoutine: '1 flacon = 30 jours de routine', regenereRoutine: '1 flacon = 30 jours = 60 gélules · 2 gélules/jour',
      shippingFrom: 'Livraison offerte dès', ships: 'Expédié sous 2–4 jours', secure: 'Paiement sécurisé'
    };
  }

  function formatMoney(cents, currency, locale) {
    var numberLocale = locale === 'en' ? 'en-GB' : (locale === 'es' ? 'es-ES' : 'fr-FR');
    var amount = Number(cents || 0);
    try {
      return new Intl.NumberFormat(numberLocale, {
        style: 'currency', currency: currency || 'EUR', minimumFractionDigits: amount % 100 === 0 ? 0 : 2, maximumFractionDigits: 2
      }).format(amount / 100);
    } catch (error) {
      return (amount / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  function track(eventName, params) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: eventName }, params || {}));
    } catch (error) {}
  }

  function adapterFor(root) {
    if (!root) return null;
    if (root.matches('[data-regenere-offer-test]')) {
      return {
        kind: 'regenere', data: '[data-regenere-data]', tiers: '[data-regenere-tiers]', modes: '[data-regenere-modes]',
        note: '[data-regenere-mode-note]', heading: '.regenere-offer__heading-row', reassurance: '.regenere-offer__reassurance',
        cta: '[data-regenere-cta]', ctaText: '[data-regenere-cta-text]'
      };
    }
    if (root.matches('[data-eclo-supp-offer-v15]')) {
      return {
        kind: 'supplement', data: '[data-eclo-supp-data-v15]', tiers: '[data-eclo-supp-tiers-v15]', modes: '[data-eclo-supp-modes-v15]',
        note: '[data-eclo-supp-mode-note-v15]', heading: '.eclo-offer__heading-row', reassurance: '.eclo-offer__reassurance',
        cta: '[data-eclo-supp-cta-v15]', ctaText: '[data-eclo-supp-cta-text-v15]'
      };
    }
    return null;
  }

  function createController(root) {
    var adapter = adapterFor(root);
    if (!adapter) return null;

    var dataNode = q(root, adapter.data);
    var headingNode = q(root, adapter.heading);
    var cta = q(root, adapter.cta);
    var ctaText = q(root, adapter.ctaText);
    if (!dataNode || !headingNode || !cta || !ctaText) return null;

    var data;
    try { data = JSON.parse(dataNode.textContent); } catch (error) { return null; }

    var tiers = (data.variants || []).map(function (variant) {
      return { months: detectMonths(variant.title), variant: variant };
    }).sort(function (a, b) { return a.months - b.months; });
    if (!tiers.length) return null;

    var locale = localeFor(root);
    var copy = words(locale);
    var params = new URLSearchParams(window.location.search);
    var freeShippingThreshold = parseInt(root.dataset.freeShippingThreshold || '5000', 10);
    var country = String(root.dataset.country || '').toUpperCase();
    var baseDefaultMonths = parseInt(root.dataset.defaultMonths || '1', 10);
    if ([1, 2, 3].indexOf(baseDefaultMonths) < 0) baseDefaultMonths = 1;
    var baseDefaultMode = String(root.dataset.defaultMode || 'onetime').toLowerCase();

    function configuredDefaultMonths() {
      var months = parseInt(config().defaultMonths || baseDefaultMonths || 1, 10);
      return [1, 2, 3].indexOf(months) >= 0 ? months : 1;
    }

    function tierFor(months) {
      for (var i = 0; i < tiers.length; i += 1) if (tiers[i].months === months) return tiers[i];
      return tiers[0];
    }

    function findPlan(tier) {
      var plans = tier && tier.variant && tier.variant.plans ? tier.variant.plans : [];
      if (!plans.length) return null;
      if (plans.length === 1) return plans[0];
      for (var i = 0; i < plans.length; i += 1) if (detectMonths(plans[i].name) === tier.months) return plans[i];
      return plans[0];
    }

    function oneTime(months) {
      var tier = tierFor(months);
      return tier && tier.variant ? Number(tier.variant.price || 0) : 0;
    }

    function subscription(months) {
      var tier = tierFor(months);
      var plan = findPlan(tier);
      return plan ? Number(plan.price || 0) : oneTime(months);
    }

    var oneMonthTier = tierFor(1);
    var oneMonthPrice = Number(oneMonthTier.variant.price || 0);
    var oneMonthCompare = Number(oneMonthTier.variant.compareAtPrice || oneMonthTier.variant.compare_at_price || 0);
    var regularUnit = oneMonthCompare > oneMonthPrice ? oneMonthCompare : oneMonthPrice;

    function fullPrice(months) { return regularUnit * months; }
    function savingPercent(base, current) { return base > current && base > 0 ? Math.round(((base - current) / base) * 100) : 0; }
    function subscriptionExtraPercent(months) { return savingPercent(oneTime(months), subscription(months)); }

    var defaultMonths = configuredDefaultMonths();
    var requestedMonths = parseInt(params.get('cure') || String(defaultMonths), 10);
    var state = {
      months: [1, 2, 3].indexOf(requestedMonths) >= 0 ? requestedMonths : defaultMonths,
      mode: 'onetime'
    };
    var requestedMode = String(params.get('mode') || config().defaultMode || baseDefaultMode).toLowerCase();
    if (requestedMode === 'sub' || requestedMode === 'subscription') state.mode = 'subscription';
    if (!findPlan(tierFor(state.months))) state.mode = 'onetime';

    var mount = document.createElement('div');
    mount.className = 'eclo-offer-v6';
    mount.setAttribute('data-eclo-offer-v6', '');
    headingNode.insertAdjacentElement('afterend', mount);

    function applyConfig() {
      var cfg = config();
      root.classList.add('eclo-offer-v6-active');
      root.classList.remove('eclo-offer-v6-style-f3', 'eclo-offer-v6-style-f4');
      root.classList.add('eclo-offer-v6-style-' + (cfg.style === 'f4' ? 'f4' : 'f3'));
      root.setAttribute('data-eclo-offer-v6-product', cfg.product || adapter.kind);
    }

    function hideLegacy() {
      [q(root, adapter.heading), q(root, adapter.tiers), q(root, adapter.modes), q(root, adapter.note), q(root, adapter.reassurance)].forEach(function (node) {
        if (!node) return;
        node.style.setProperty('display', 'none', 'important');
        node.setAttribute('aria-hidden', 'true');
      });

      var formWidth = root.closest('.form__width') || root.closest('.product__content') || root.parentNode;
      qa(formWidth, '.product__block').forEach(function (block) {
        if (block.contains(root)) return;
        var text = String(block.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
        var duplicateShipping = text.indexOf('envoi sous 2 jours ouvrés') >= 0 || text.indexOf('ships within 2 business days') >= 0;
        var duplicateRegenereDose = adapter.kind === 'regenere' && (text.indexOf('60 gélules · 30 jours · 2 gélules par jour') >= 0 || text.indexOf('60 capsules · 30 days · 2 capsules per day') >= 0);
        if (duplicateShipping || duplicateRegenereDose) {
          block.hidden = true;
          block.setAttribute('aria-hidden', 'true');
          block.style.setProperty('display', 'none', 'important');
        }
      });
    }

    function legacyButton(containerSelector, attribute, value) {
      var container = q(root, containerSelector);
      return container ? q(container, '[' + attribute + '=\"' + value + '\"]') : null;
    }

    function syncLegacy() {
      var tierButton = legacyButton(adapter.tiers, 'data-months', state.months);
      if (tierButton && !tierButton.disabled && !tierButton.classList.contains('is-selected')) tierButton.click();
      var modeButton = legacyButton(adapter.modes, 'data-mode', state.mode);
      if (modeButton && !modeButton.disabled && !modeButton.classList.contains('is-selected')) modeButton.click();
    }

    function monthLabel(months) { return months + ' ' + (months === 1 ? copy.month : copy.months); }
    function durationLabel(months) { return (30 * months) + ' ' + copy.daysAverage; }
    function currentPrice(months, mode) { return mode === 'subscription' ? subscription(months) : oneTime(months); }
    function cardMeta(months, current) {
      if (config().showDailyPrice) {
        return formatMoney(current / (months * 30), data.currency, locale) + ' ' + copy.perDay;
      }
      return (months * 30) + ' ' + copy.days;
    }

    function shippingBadge(total) {
      if (country === 'SG' || total < freeShippingThreshold) return '';
      return '<span class="eclo-v6__shipping">' + escapeHtml(copy.freeShipping) + '</span>';
    }

    function card(months, isSubscription) {
      var mode = isSubscription ? 'subscription' : 'onetime';
      var current = currentPrice(months, mode);
      var benchmark = fullPrice(months);
      var discount = savingPercent(benchmark, current);
      var selected = state.months === months;
      var available = tierFor(months).variant.available !== false;
      var disabled = isSubscription && !findPlan(tierFor(months));
      var badge = discount ? '<span class="eclo-v6__badge">−' + discount + '%</span>' : '';
      var price = benchmark > current
        ? '<span class="eclo-v6__card-price"><s>' + escapeHtml(formatMoney(benchmark, data.currency, locale)) + '</s><b>' + escapeHtml(formatMoney(current, data.currency, locale)) + '</b></span>'
        : '<span class="eclo-v6__card-price"><b>' + escapeHtml(formatMoney(current, data.currency, locale)) + '</b></span>';
      return [
        '<button type="button" class="eclo-v6__card', isSubscription ? ' eclo-v6__card--subscription' : '', selected ? ' is-selected' : '',
        '" data-eclo-v6-months="', months, '"', (!available || disabled) ? ' disabled aria-disabled="true"' : '', '>',
        badge, '<span class="eclo-v6__card-title">', escapeHtml(monthLabel(months)), '</span>',
        '<span class="eclo-v6__card-meta">', escapeHtml(cardMeta(months, current)), '</span>', price, shippingBadge(current), '</button>'
      ].join('');
    }

    function benefits() {
      return [
        '<div class="eclo-v6__benefits">',
        '<div class="eclo-v6__benefit"><span class="eclo-v6__check">✓</span><span><strong>', escapeHtml(copy.saveMore), '</strong> ', escapeHtml(copy.perOrder), '</span></div>',
        '<div class="eclo-v6__benefit"><span class="eclo-v6__check">✓</span><span><strong>', escapeHtml(copy.exclusive), '</strong> ', escapeHtml(copy.exclusiveTail), '</span></div>',
        '<div class="eclo-v6__benefit"><span class="eclo-v6__check">✓</span><span><strong>', escapeHtml(copy.loyalty), '</strong> ', escapeHtml(copy.loyaltyTail), '</span></div>',
        '<div class="eclo-v6__benefit"><span class="eclo-v6__check">✓</span><span><strong>', escapeHtml(copy.noCommitment), '</strong>, ', escapeHtml(copy.cancelAnytime), '</span></div>',
        '</div>'
      ].join('');
    }

    function panel() {
      var isSubscription = state.mode === 'subscription';
      var current = currentPrice(state.months, state.mode);
      var benchmark = fullPrice(state.months);
      var price = benchmark > current
        ? '<div class="eclo-v6__head-price"><s>' + escapeHtml(formatMoney(benchmark, data.currency, locale)) + '</s><b>' + escapeHtml(formatMoney(current, data.currency, locale)) + '</b></div>'
        : '<div class="eclo-v6__head-price"><b>' + escapeHtml(formatMoney(current, data.currency, locale)) + '</b></div>';
      return [
        '<div class="eclo-v6__panel"><div class="eclo-v6__panel-head"><div class="eclo-v6__mode"><span class="eclo-v6__radio"></span><div>',
        '<div class="eclo-v6__mode-title">', escapeHtml(isSubscription ? copy.subscription : copy.oneTime), '</div>',
        isSubscription ? '<div class="eclo-v6__mode-sub">' + escapeHtml(copy.flexible) + '</div>' : '', '</div></div>', price, '</div>',
        isSubscription ? '<div class="eclo-v6__delivered">' + escapeHtml(copy.deliveredEvery) + '</div>' : '',
        '<div class="eclo-v6__cards">', [1, 2, 3].map(function (months) { return card(months, isSubscription); }).join(''), '</div>',
        isSubscription ? benefits() : '', '</div>'
      ].join('');
    }

    function switchRow() {
      var on = state.mode === 'subscription';
      var extra = subscriptionExtraPercent(state.months) || subscriptionExtraPercent(1) || 15;
      return [
        '<button type="button" class="eclo-v6__switch-row', on ? ' is-on' : '', '" data-eclo-v6-switch role="switch" aria-checked="', on ? 'true' : 'false', '">',
        '<span class="eclo-v6__switch-copy"><span class="eclo-v6__switch-title"><span>', escapeHtml(copy.save), '</span><span class="eclo-v6__switch-badge">−', extra,
        '%</span><span>', escapeHtml(copy.withSubscription), '</span></span><span class="eclo-v6__switch-sub"><strong>', escapeHtml(copy.noCommitment),
        '</strong>, ', escapeHtml(copy.cancelAnytime), '</span></span><span class="eclo-v6__toggle"></span></button>'
      ].join('');
    }

    function updateCta() {
      var current = currentPrice(state.months, state.mode);
      var benchmark = fullPrice(state.months);
      ctaText.innerHTML = [
        '<span class="eclo-v6__cta-left">', escapeHtml(copy.add), '</span><span class="eclo-v6__cta-price"><b>',
        escapeHtml(formatMoney(current, data.currency, locale)), '</b>', benchmark > current ? '<s>' + escapeHtml(formatMoney(benchmark, data.currency, locale)) + '</s>' : '', '</span>'
      ].join('');
    }

    function ensureReassurance() {
      var box = q(root, '[data-eclo-v6-reassurance]');
      if (!box) {
        box = document.createElement('div');
        box.className = 'eclo-v6__reassurance';
        box.setAttribute('data-eclo-v6-reassurance', '');
        cta.insertAdjacentElement('afterend', box);
      }
      var firstLine = adapter.kind === 'regenere' ? copy.regenereRoutine : copy.bottleRoutine;
      var shippingLine = country === 'SG'
        ? copy.ships + ' · ' + copy.secure
        : copy.shippingFrom + ' ' + formatMoney(freeShippingThreshold, data.currency, locale) + ' · ' + copy.ships + ' · ' + copy.secure;
      box.innerHTML = '<strong>' + escapeHtml(firstLine) + '</strong><span>' + escapeHtml(shippingLine) + '</span>';
    }

    function render() {
      applyConfig();
      hideLegacy();
      mount.innerHTML = '<div class="eclo-v6__top"><span>' + escapeHtml(copy.choose) + '</span><span class="eclo-v6__average">' + escapeHtml(durationLabel(state.months)) + '</span></div>' + panel() + switchRow();

      qa(mount, '[data-eclo-v6-months]').forEach(function (button) {
        button.addEventListener('click', function () {
          var months = parseInt(button.getAttribute('data-eclo-v6-months') || '1', 10);
          state.months = [1, 2, 3].indexOf(months) >= 0 ? months : 1;
          if (state.mode === 'subscription' && !findPlan(tierFor(state.months))) state.mode = 'onetime';
          syncLegacy();
          render();
          track('eclo_offer_v6_select', {
            offer_version: 'v6', offer_style: config().style || 'f3', product_key: config().product || adapter.kind,
            purchase_mode: state.mode === 'subscription' ? 'sub' : 'onetime', tier_months: state.months, interaction_source: 'duration'
          });
        });
      });

      var switchButton = q(mount, '[data-eclo-v6-switch]');
      if (switchButton) {
        switchButton.disabled = !findPlan(tierFor(state.months));
        switchButton.addEventListener('click', function () {
          if (!findPlan(tierFor(state.months))) return;
          state.mode = state.mode === 'subscription' ? 'onetime' : 'subscription';
          syncLegacy();
          render();
          track('eclo_offer_v6_select', {
            offer_version: 'v6', offer_style: config().style || 'f3', product_key: config().product || adapter.kind,
            purchase_mode: state.mode === 'subscription' ? 'sub' : 'onetime', tier_months: state.months, interaction_source: 'subscription-toggle'
          });
        });
      }

      updateCta();
      ensureReassurance();
    }

    applyConfig();
    hideLegacy();
    syncLegacy();
    render();
    root.dataset.ecloOfferV6Ready = 'true';
    track('eclo_offer_v6_exposure', {
      offer_version: 'v6', offer_style: config().style || 'f3', product_key: config().product || adapter.kind,
      purchase_mode: state.mode === 'subscription' ? 'sub' : 'onetime', tier_months: state.months
    });

    return {
      refresh: function () {
        locale = localeFor(root);
        copy = words(locale);
        if (window.Shopify && window.Shopify.designMode) {
          if (!params.get('cure')) state.months = configuredDefaultMonths();
          if (!params.get('mode')) {
            var defaultMode = String(config().defaultMode || baseDefaultMode).toLowerCase();
            state.mode = defaultMode === 'subscription' ? 'subscription' : 'onetime';
          }
          if (!findPlan(tierFor(state.months))) state.mode = 'onetime';
          syncLegacy();
        }
        render();
      }
    };
  }

  function tryInit(root, attempt) {
    if (!root) return;
    if (root.__ecloOfferV6Controller) {
      root.__ecloOfferV6Controller.refresh();
      return;
    }
    var adapter = adapterFor(root);
    if (!adapter) return;
    var tiersNode = q(root, adapter.tiers);
    var modesNode = q(root, adapter.modes);
    var legacyReady = tiersNode && modesNode && q(tiersNode, '[data-months]') && q(modesNode, '[data-mode]');
    if (!legacyReady) {
      if ((attempt || 0) < 80) window.setTimeout(function () { tryInit(root, (attempt || 0) + 1); }, 75);
      return;
    }
    root.__ecloOfferV6Controller = createController(root);
  }

  function initAll(scope) {
    var area = scope || document;
    qa(area, '[data-regenere-offer-test], [data-eclo-supp-offer-v15]').forEach(function (root) { tryInit(root, 0); });
  }

  function refreshAll() {
    qa(document, '[data-regenere-offer-test], [data-eclo-supp-offer-v15]').forEach(function (root) {
      if (root.__ecloOfferV6Controller) root.__ecloOfferV6Controller.refresh();
      else tryInit(root, 0);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target || document);
    window.setTimeout(refreshAll, 0);
  });
  document.addEventListener('eclo:offer-v6-config', refreshAll);
  document.addEventListener('eclo:offer-v6-refresh', refreshAll);
})();
